import { Route } from "@/types/routes"
import { defaultShouldRedirect, defaultRedirectTo } from "./shared"

export const mapRoute: Route = {
  isPublic: false,
  shouldRedirect: defaultShouldRedirect,
  redirectTo: defaultRedirectTo,
}
